export default __webpack_public_path__ + "static/asia-icon-1d1f5d9fad0135ea6f794d6569b38e19.svg";